export const lang = {
	//title为每个页面的标题
	title: '设备共享出售出租',
}
